import { GridColDef } from "@mui/x-data-grid";
import React, { useEffect, useRef, useState } from "react";
import { Card } from "react-bootstrap";
import { useMutation } from "react-query";
import { KTCard } from "../../_metronic/helpers";
import CustomTooltip from "../../_metronic/layout/components/common/CustomTooltip";
import { getAllContactUs } from "../../api";
import MuiTable from "../../components/table/MuiTable";
import { charValidate } from "../../components/utility";
import useDebounce from "../../hooks/useDebounce";

const ContactUsLogs: React.FC = () => {
  const tableRef = useRef(null);

  const [tableOptions, setTableOptions] = useState({
    skip: 0,
    take: 10,
    totalRowCount: undefined,
    SearchText: "",
  });

  const debounceSearchValue: string = useDebounce(
    tableOptions?.SearchText,
    500,
  );

  const {
    mutateAsync: getContactUsAPI,
    data: contactUsDataList,
    isLoading: isGettingListData,
  } = useMutation(getAllContactUs);

  useEffect(() => {
    getContactUsLogList({
      ...tableOptions,
      SearchText: debounceSearchValue ?? "",
    });
  }, [debounceSearchValue]);

  const getContactUsLogList = async (
    query:
      | {
          skip: number;
          take: number;
          SearchText: string;
        }
      | undefined,
  ) => {
    let response = await getContactUsAPI(query);

    if (response?.result) {
      setTableOptions((prevState: any) => {
        return {
          ...prevState,
          skip: response?.pageDetail?.skip ?? 0,
          take: response?.pageDetail?.take ?? 10,
          SearchText: response?.pageDetail?.searchText ?? "",
          totalRowCount: response?.pageDetail?.count ?? 0,
        };
      });
    }
  };

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      sortable: false,
      minWidth: 200,
      renderCell: (data: any) => (
        <CustomTooltip
          title={
            data?.row ? (
              <h6 style={{ color: "white" }}>{data?.row?.name}</h6>
            ) : (
              "N/A"
            )
          }
        >
          <span>{`${data?.row?.name}`}</span>
        </CustomTooltip>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      sortable: false,
      minWidth: 200,
      renderCell: (data: any) => (
        <CustomTooltip
          title={
            data?.row ? (
              <h6 style={{ color: "white" }}>{data?.row?.email}</h6>
            ) : (
              "N/A"
            )
          }
        >
          <span>{`${data?.row?.email}`}</span>
        </CustomTooltip>
      ),
    },
    {
      field: "address",
      headerName: "Address",
      flex: 1,
      sortable: false,
      minWidth: 270,
      renderCell: (data: any) => (
        <CustomTooltip
          title={
            data?.row?.address ? (
              <h6 style={{ color: "white" }}>{data?.row?.address}</h6>
            ) : (
              "N/A"
            )
          }
        >
          <span>
            {data?.row?.address ? charValidate(data?.row?.address, 40) : "N/A"}
          </span>
        </CustomTooltip>
      ),
    },
    {
      field: "phone",
      headerName: "Phone Number",
      flex: 1,
      sortable: false,
      minWidth: 200,
      renderCell: (data: any) => (
        <CustomTooltip
          title={
            data?.row ? (
              <h6 style={{ color: "white" }}>{data?.row?.phone}</h6>
            ) : (
              "N/A"
            )
          }
        >
          <span>{`${data?.row?.phone}`}</span>
        </CustomTooltip>
      ),
    },
    {
      field: "message",
      headerName: "Message",
      flex: 1,
      sortable: false,
      minWidth: 270,
      renderCell: (data: any) => (
        <CustomTooltip
          title={
            data?.row?.message ? (
              <h6 style={{ color: "white" }}>{data?.row?.message}</h6>
            ) : (
              "N/A"
            )
          }
        >
          <span>
            {data?.row?.message ? charValidate(data?.row?.message, 40) : "N/A"}
          </span>
        </CustomTooltip>
      ),
    },
  ];

  let defaultQuery = {
    skip: 0,
    take: 10,
    SearchText: "",
  };

  const handlePagination = (values: { page: number; pageSize: number }) => {
    let page = values?.page;
    let pageSize = values?.pageSize;
    let offsetValue = page * pageSize;

    let query: any = {
      skip: offsetValue,
      take: pageSize ?? 10,
      SearchText: "",
    };

    setTableOptions((prev) => ({
      ...prev,
      skip: offsetValue,
      take: pageSize,
    }));

    getContactUsLogList(query);
  };

  const handleLastPage: any = () => {
    const totalPages = Math.ceil(
      (tableOptions?.totalRowCount ?? 0) / (tableOptions?.take ?? 10),
    );
    const lastPage = totalPages > 0 ? totalPages - 1 : 0;

    console.log("lastPage", lastPage);
    console.log("totalPages ", totalPages);
    console.log("tableOptions?.take", tableOptions);

    handlePagination({
      page: lastPage,
      pageSize: tableOptions?.take,
    });
  };

  const handleFirstPage: any = () => {
    const firstPage = 0;
    handlePagination({ page: firstPage, pageSize: tableOptions?.take });
  };

  return (
    <Card className="p-6">
      <>
        <KTCard>
          <h3 style={{ position: "absolute", top: "5px" }}>Contact Us Logs</h3>
          <div style={{ marginTop: "50px" }}>
            <MuiTable
              columns={columns}
              tableRef={tableRef}
              isRowClickable={true}
              handlePagination={handlePagination}
              handleLastPage={handleLastPage}
              handleFirstPage={handleFirstPage}
              tableOptions={tableOptions}
              isAddEnable={false}
              isDividerVisible={false}
              data={contactUsDataList?.result || []}
              loading={isGettingListData}
            />
          </div>
        </KTCard>
      </>
    </Card>
  );
};

export default ContactUsLogs;
